import React from "react";
import { Outlet } from "react-router-dom";

import BrandSidebar from "../components/BrandSidebar";

export default function BrandDashboard({ brand }) {

    return (

        <div
            style={{
                display: "flex",
                width: "100%",
                height: "100vh",
                background: "#f5f7fb"
            }}
        >

            <BrandSidebar />

            <div
                style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column"
                }}
            >

                {/* Header */}

                <div
                    style={{
                        height: 72,
                        background: "#fff",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 30px",
                        borderBottom: "1px solid #e5e7eb"
                    }}
                >

                    <div>

                        <h2
                            style={{
                                margin: 0
                            }}
                        >
                            {brand?.brandName}
                        </h2>

                        <div
                            style={{
                                color: "#666",
                                marginTop: 4
                            }}
                        >
                            {brand?.businessType}
                        </div>

                    </div>

                    <div>

                        Welcome 👋

                    </div>

                </div>

                {/* Page Content */}

                <div
                    style={{
                        flex: 1,
                        padding: 30,
                        overflow: "auto"
                    }}
                >

                    <Outlet />

                </div>

            </div>

        </div>

    );

}